import { render } from "./TableSetting.vue?vue&type=template&id=c65c0d28"
import script from "./TableSetting.vue?vue&type=script&lang=js"
export * from "./TableSetting.vue?vue&type=script&lang=js"

import "./TableSetting.vue?vue&type=style&index=0&id=c65c0d28&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__